class ConfigService {
  constructor() {
    this._config = {};
    this._loaded = false;
    this._callbacks = [];
  }

  async loadConfig() {
    return fetch('/api/config/config.json')
      .then(async (resp) => {
        const text = await resp.text();
        try {
          return JSON.parse(text);
        } catch (err) {
          console.error('Failed to parse /api/config/config.json. Raw response:', text);
          throw err;
        }
      })
      .then(json => {
        const conf = { ...json };
        conf.API_URL = conf.BASE_SERVER_URL + conf.API_URL;
        if (conf.DEBUG) {
          console.debug(conf);
        } else {
          // debug disabled
        }
        return conf;
      });
  }

  registerCallback(callback, name) {
    if (this._loaded) {
      if (this.config.DEBUG) {
        console.info(`Config already loaded, invoking '${name}' callback imediately`);
      } else {
        // debug disabled
      }
      callback(this.config);
    } else {
      this._callbacks.push({ callback, name });
    }
  }

  initializeConfig() {
    if (!this._loaded) {
      return this.loadConfig()
        .then(conf => {
          this._config = conf;
          this._loaded = true;
          if (conf.DEBUG) {
            console.info("Config has been loaded into service", conf);
            console.info(`Calling ${this._callbacks.length} callbacks`);
          } else {
            // debug disabled
          }
          this._callbacks.forEach(callbackItem => {
            if (conf.DEBUG) {
              console.info(`Config loaded, invoking '${callbackItem.name}' callback now`);
            } else {
              // debug disabled
            }
            callbackItem.callback(this.config);
          });
        }).catch(err => {
          console.error("Error while loading config", err);
        });
    } else {
      return null;
    }
  }

  get config() {
    return this._config;
  }

  get loaded() {
    return this._loaded;
  }

  get hiveApiUrl() {
    return this.config.API_URL;
  }

  get eventsApiUrl() {
    return this.config.EVENT_SERVER_URL;
  }

  get graphApi() {
    return this.config.MSGRAPHAPI;
  }

  get scopes() {
    return this.config.SCOPES;
  }

  get debug() {
    return this.config.DEBUG;
  }

  get baseUrl() {
    return this.config.BASE_SERVER_URL;
  }

  get refreshTimeout() {
    return this.config.REFRESH_TIMEOUT;
  }

  /** Where a BROWSER reaches SILO, as opposed to the /api/silo/* proxy the
   *  app's own fetch() calls use. A path on this origin in the hosted
   *  deployment, SILO's own origin when it runs standalone. */
  get siloUrl() {
    return this.config.SILO_URL;
  }

  get storageAccountBaseUrl() {
    return this.config.STORAGE_ACCOUNT_BASE_URL;
  }

  get eventImagesStorageContainer() {
    return this.config.EVENT_IMAGES_STORAGE_CONTAINER;
  }

  get maximumImageUploadFileSize() {
    return this.config.MAXIMUM_IMAGE_FILE_SIZE_MB;
  }

  get feedbackFormDebounceThresholdInMilliseconds() {
    return this.config.FEEDBACK_FORM_DEBOUNCE_THRESHOLD_IN_MILLISECONDS;
  }

  get maximumFileSize() {
    return this.config.MAXIMUM_FILE_SIZE_MB;
  }

  get skillsFileDefault() {
    return this.config.SKILL_FILE_DEFAULT;
  }
  
  get skillMaxCharacterLimit() {
    return this.config.SKILL_MAX_CHARACTER_LIMIT;
  }

  get skillCertificationExpiryThreshold() {
    return this.config.SKILL_CERTIFICATION_EXPIRY_THRESHOLD;
  }

  get minimumContractDuration() {
    return this.config.MINIMUM_CONTRACT_DURATION;
  }

  get skillMinSearchCharacters() {
    return this.config.SKILL_MIN_SEARCH_CHARACTERS;
  }

  get initialVisibleUnitSkillRecommendations() {
    return this.config.INITIAL_VISIBLE_UNIT_SKILL_RECOMMENDATIONS;
  }

  get searchDebounceTimeInMilliseconds() {
    return this.config.SEARCH_DEBOUNCE_TIME_IN_MILLISECONDS;
  }
}

export default new ConfigService();